import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { DialogActions } from "../actions";
import { CloseDialogPayload, OpenDialogPayload } from "../actions/dialog.action";

@Injectable()
export class DialogEffects {
    openDialog$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(DialogActions.openDialog),
                tap((payload: OpenDialogPayload) => this.dialog.open(payload.componentOrTemplateRef, payload.config))
            ),
        { dispatch: false }
    );

    closeDialog$: Observable<CloseDialogPayload> = createEffect(
        () =>
            this.actions$.pipe(
                ofType(DialogActions.closeDialog),
                tap(({ dialogId, responseData }) => this.dialog.getDialogById(dialogId).close(responseData))
            ),
        { dispatch: false }
    );

    constructor(private actions$: Actions, private dialog: MatDialog) {}
}
